import React, { useState, useEffect } from "react";
import { useParams,useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import CryptoJS from "crypto-js";
import "./Scheme.css";
import Input from "./Input";
import Select from "./Select";
import { Badge } from "react-bootstrap";
import green_check from "./../../../images/svg/green-check.svg";
import Modal from "./Modal";
import { getAllDistrictList, getAllSportList } from "../../../services/commonApiService/CommonApiService";
import { uploadSchemeDocument, applyForScheme, getUserDetails } from "../../../services/schemeApiService/SchemeApiService";
import DatePickerField from "./DatePickerField";
import ViewDocument from "./ViewDocument";

const alreadyUploadedDocUrl= process.env.REACT_APP_BASE_URL+"/storage";

const MAX_PHOTO_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_DOC_SIZE = 2 * 1024 * 1024; // 2MB

const SchemeForm = () => {

  const navigate = useNavigate();

  const { encryptedSchemeId } = useParams();
      
  let secretKey = process.env.REACT_APP_SECRET_KEY ;
  let bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedSchemeId), secretKey);
  let schemeId = bytes.toString(CryptoJS.enc.Utf8);

  const [formData, setFormData] = useState({"gender":"","district":"","sport":"","medal":"","competition":"","sport_category_senior_junior":"","sport_category_team_ind":"","contact":"","aadhar":"","pincode":"","player_bank_account_number":"","number_of_players":null,"coach_pincode":"","coach_contact":"","coach_bank_account_number":"","rec_dep_mobile":""});
  const [errors, setErrors] = useState({});
  const [isDeclared, setIsDeclared] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [readOnlyFields, setReadOnlyFields] = useState([]);
  const [fetchedAadhaar, setFetchedAadhaar] = useState(null);
  const [fetchedProfile, setFetchedProfile] = useState(null);

  // const [profilePhoto, setProfilePhoto] = useState(null);

  const [competetionTypes, setCompetetionTypes]=useState([
    { id: 1, label: 'Olympic Games' },
    { id: 2, label: 'World cup/Championship' },
    { id: 3, label: 'Asian games' },
    { id: 4, label: 'Commonwealth games' },
    { id: 5, label: 'Asian Championship' },
    { id: 6, label: 'Commonwealth Championship' },
    { id: 7, label: 'South Asian Games' },
    { id: 8, label: 'National Games' },
    { id: 9, label: 'World university games/World School Games, World Police Games' },
    { id: 10, label: 'International Veteran Master Championship' },
    { id: 11, label: 'National championship, National School Games, Khelo India Games, All India Rural Games, National Women Games' },
    { id: 12, label: 'All India University Championship/Tournament, Khelo India University Games' },
    { id: 13, label: 'National Civil Services Competition, All India Police Tournament' },
    { id: 14, label: 'National Veteran Master championship' },
  ]);
  
  const [medalList, setMedalList]=useState([
    { id: 1, label: 'Gold' },
    { id: 2, label: 'Silver' },
    { id: 3, label: 'Bronze' },
    { id: 4, label: 'Participation' },
  ]);
  const [genderList, setGenderList]=useState([
    { id: "M", label: 'Male' },
    { id: "F", label: 'Female' },
    { id: "O", label: 'Other' }
  ]);

  const [districtList, setDistrictList]=useState([
    // { id: 1, label: 'Almora' },
    // { id: 2, label: 'Dehradun' }
  ]);

  const [sportList, setSportList]=useState([
    // { id: 1, label: 'Badminton' },
    // { id: 2, label: 'Kho-kho' }
  ]);

  const [sportCategoryList, setSportCategoryList]=useState([
    { id: 1, label: 'Senior' },
    { id: 2, label: 'Junior/youth' },
    { id: 3, label: 'Sub-junior' },
    { id: 4, label: 'Other' }
  ]);

  const [sportCategoryTeamIndList, setSportCategoryTeamIndList]=useState([
    { id: 1, label: 'Individual' },
    { id: 2, label: 'Team' }
  ]);

    const fetchDistricts = async () => {
      try {
        const response = await getAllDistrictList(4016);

        let transformedData = response.data.map(item => ({
          id: item.id,
          label: item.name
        }));

        setDistrictList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    const fetchSports = async () => {
      try {
        const response = await getAllSportList();
        // console.log(response.data);

        let transformedData = response.data.data.map(item => ({
          id: item.sport_id,
          label: item.sport_name
        }));

        setSportList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    // const formatDate = (dateStr) => {
    //   const [year, month, day] = dateStr.split('-');
    //   return `${day}-${month}-${year}`;
    // };

    const fetchUserDetails = async () => {
      try {
        const response = await getUserDetails();
        console.log(response.data.data);
        let userdetails=response.data.data;
        setFormData({
          ...formData,
          "name":`${userdetails.first_name}${userdetails.middle_name?" "+userdetails.middle_name:""}${userdetails.last_name?" "+userdetails.last_name:""}`,
          "father_name":userdetails.father_name,
          "dob":userdetails.dob,
          "gender":userdetails.gender,
          "email":userdetails.email,
          "aadhar":userdetails.identity_card,
          "contact":userdetails.mobile,
          "address":userdetails.address,
          "district":userdetails.city,
          "pincode":userdetails.pincode,
          "player_bank_account_number":userdetails.bank_account_number,
          "player_ifsc_code":userdetails.ifsc_code,
          "player_bank_name":userdetails.bank_name,
          "player_bank_branch":userdetails.branch_name,
          });

          let readonly=[];

          if(userdetails.identity_card!=null){
            // console.log("identity_card",userdetails.identity_card);
            readonly.push("aadhar");
          }
          if(userdetails.city!=null){
            // console.log("district",userdetails.city);
            readonly.push("district");
          }
          if(userdetails.bank_account_number!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_account_number");
          }
          if(userdetails.ifsc_code!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_ifsc_code");
          }
          if(userdetails.branch_name!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_name");
          }
          if(userdetails.branch_name!=null){
            // console.log("district",userdetails.city);
            readonly.push("player_bank_branch");
          }

          setReadOnlyFields([...readOnlyFields,...readonly]);

          const documents = userdetails.documents || [];

          // console.log("documents",documents);

          const getDocumentPath = (type) => {
            const doc = documents.find(d => d.doc_name === type);
            return doc ? doc.doc_file : "";
          };

          if(getDocumentPath("profile_image")){
            setFetchedProfile(getDocumentPath("profile_image"));
          }
          if(getDocumentPath("aadhaar")){
            setFetchedAadhaar(getDocumentPath("aadhaar"));
          }

        

      } catch (error) {
        console.error("Error fetching userdetails:", error);
      }
    };
  
    // Fetch cities, and sports on initial render
    useEffect(() => {
      fetchDistricts();
      fetchSports();
      fetchUserDetails();
    }, []);

  function fieldName(field) {
    switch (field) {
      case "name":
        return "Player's Name";
      case "father_name":
        return "Father's Name";
      case "dob":
        return "Date of Birth";
      case "gender":
        return "Gender";
      case "email":
        return "Email ID";
      case "contact":
        return "Contact Number";
      case "aadhar":
        return "Aadhar Number";
      case "address":
        return "Full Address";
      case "district":
        return "District";
      case "pincode":
        return "Pincode";
      case "sport_category_senior_junior":
        return "Sport Category";
      case "sport_category_team_ind":
        return "Sport Category";
      case "association_name":
        return "Association Name";
      case "competition_start_date":
        return "Competition Start Date";
      case "competition_end_date":
        return "Competition End Date";
      case "number_of_players":
        return "Number of Players";
      case "player_bank_account_number":
        return "Bank Account Number";
      case "player_ifsc_code":
        return "IFSC Code";
      case "player_bank_name":
        return "Bank Name";
      case "player_bank_branch":
        return "Bank Branch";
      case "coach_bank_account_number":
        return "Bank Account Number";
      case "coach_ifsc_code":
        return "IFSC Code";
      case "coach_bank_name":
        return "Bank Name";
      case "coach_bank_branch":
        return "Bank Branch";
      case "coach_name":
        return "Coach Name";
      case "coach_address":
        return "Address";
      case "coach_pincode":
        return "Pincode";
      case "coach_contact":
        return "Contact Number";
      case "rec_dep_name":
        return "Recommending Department Name";
      case "rec_dep_officer_name":
        return "Recommending Officer Name";
      case "rec_dep_address":
        return "Recommending Department Address";
      case "rec_dep_mobile":
        return "Recommending Officer Mobile";
      case "applicant_photo":
        return "Applicant's Photo";
      case "competition":
        return "Competition Name";
      case "sport":
        return "Sport";
      case "medal":
        return "Medal";
      case "training_certificate":
        return "Training Certificate";
      case "tournament_certificate":
        return "Tournament Certificate";
      case "stamp_paper_training":
        return "Stamp Paper Declaration";
      case "association_verification_form":
        return "Association Verification Form";
      case "sports_proof":
        return "Sports Proof";
      case "applicant_aadhaar":
        return "Aadhar Card";
      case "event":
        return "Event";
      default:
        return field;
    }
  }
  
  const validateFile = (file, type) => {
    if (!file) return false;
    const fileType = file.type;
    const fileSize = file.size;

    if (type === "photo") {
      return (["image/jpeg", "image/png"].includes(fileType) && fileSize <= MAX_PHOTO_SIZE);
    }

    return fileType === "application/pdf" && fileSize <= MAX_DOC_SIZE;
  };

  const handleFileChange = async (e, name, type) => {

    const file = e.target.files[0];
    const isValid = validateFile(file, type);

    setFormData(prev => ({ ...prev, [name]: file }));
    setErrors(prev => ({
      ...prev,
      [name]: isValid ? null : `Invalid ${fieldName(name)} file (${type === "photo" ? "jpeg/png < 2mb" : "pdf < 2mb"})`
    }));

    if(isValid){

      if (file) {
        let payload = {};
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = async () => {
              try {
                payload.document=file;
                payload.applicant_id=applicationId;
                payload.document_type=name;
                payload.scheme_id=schemeId;
                let res = await uploadSchemeDocument(payload);
                // console.log(res);
                if(res.data.success){
                  // console.log(res.data.data.applicant_id);
                  setApplicationId(res.data.data.applicant_id);
                }
              } catch (error) {
                console.log(error);
              }
            };

      
    }
    }
  };

  const handleSelectChange = (e, name) => {
    setFormData({ ...formData, [name]: e.target.value });
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  const submitForm=async()=>{
    setSubmitLoading(true);
    formData.applicant_id=applicationId;
    formData.scheme_id=schemeId;
    let res = await applyForScheme(formData);
    // console.log(res);
    if(res.data.success){
      setSubmitLoading(false);
      setFormData({"gender":"","district":"","sport":"","medal":"","competition":"","sport_category_senior_junior":"","sport_category_team_ind":""});
      setTimeout(() => {
        setModalOpen(true);
      }, 500);
    }else{
      setSubmitLoading(false);
      toast.error("Error occured while submitting form !", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const handleSubmit = (e) => {

    e.preventDefault();

    const requiredFields = [
      { name: "name" },
      { name: "father_name" },
      { name: "dob" },
      { name: "gender" },
      { name: "email" },
      { name: "address" },
      { name: "contact" },
      { name: "aadhar" },
      { name: "district" },
      { name: "pincode" },
      { name: "sport_category_senior_junior" },
      { name: "sport_category_team_ind" },
      { name: "association_name" },
      { name: "competition_start_date" },
      { name: "competition_end_date" },
      { name: "event" },
      { name: "player_bank_account_number" },
      { name: "player_ifsc_code" },
      { name: "player_bank_name" },
      { name: "player_bank_branch" },
      { name: "coach_bank_account_number" },
      { name: "coach_ifsc_code" },
      { name: "coach_bank_name" },
      { name: "coach_bank_branch" },
      { name: "coach_name" },
      { name: "coach_address" },
      { name: "coach_pincode" },
      { name: "coach_contact" },
      { name: "rec_dep_name" },
      { name: "rec_dep_officer_name" },
      { name: "rec_dep_address" },
      { name: "rec_dep_mobile" },
      // { name: "applicant_photo", type: "photo" },
      // { name: "applicant_aadhaar", type: "pdf" },
      { name: "competition" },
      { name: "sport" },
      { name: "medal" },
      { name: "training_certificate", type: "pdf" },
      { name: "tournament_certificate", type: "pdf" },
      { name: "stamp_paper_training", type: "pdf" },
      { name: "association_verification_form", type: "pdf" },
      { name: "sports_proof", type: "pdf" }
    ];

    const newErrors = {};

    requiredFields.forEach(({ name, type }) => {
      let value = formData[name];

      if (value && typeof value === "string") {
        value = value.trim();
      }

      if (!value) {
        newErrors[name] = `${fieldName(name)} is required`;
      } else if (type && !validateFile(value, type === "photo" ? "photo" : "pdf")) {
        newErrors[name] = `Invalid ${name} file (${type === "photo" ? "jpeg/png < 2mb" : "pdf < 2mb"})`;
      }
    });

    const aadhar = formData["aadhar"];
    const aadharRegex = /^(?!.*(\d)\1{11})([2-9]{1}[0-9]{11})$/;
    
    if (aadhar && !aadharRegex.test(aadhar)) {
      newErrors["aadhar"] = "Enter a valid 12-digit aadhar number";
    }
  
    // ✅ Custom validation for contact numbers
    const phoneRegex = /^[6-9]\d{9}$/; // Valid Indian mobile number
  
    if (formData["contact"] && !phoneRegex.test(formData["contact"])) {
      newErrors["contact"] = "Enter a valid 10-digit phone number";
    }

    const startDate = new Date(formData["competition_start_date"]);
    const endDate = new Date(formData["competition_end_date"]);

    if (startDate && endDate && endDate < startDate) {
      newErrors["competition_end_date"] = "End date is before start date";
    }
    
  
    if (formData["coach_contact"] && !phoneRegex.test(formData["coach_contact"])) {
      newErrors["coach_contact"] = "Enter a valid 10-digit coach phone number";
    }

    if (formData["rec_dep_mobile"] && !phoneRegex.test(formData["rec_dep_mobile"])) {
      newErrors["rec_dep_mobile"] = "Enter a valid 10-digit phone number";
    }
  
    // ✅ Conditional required field: number_of_players (only if team sport)
    if (formData["sport_category_team_ind"] === "2" && !formData["number_of_players"]) {
      newErrors["number_of_players"] = "Number of players is required";
    }else if(formData["sport_category_team_ind"] === "2" && formData["number_of_players"]<1){
      newErrors["number_of_players"] = "Number of players must be greater than or equal to 1";
    }


      // Pincode: must be 6-digit number
      let pincodeRegex=/^(?!0{6}$)\d{6}$/;
      const pincodeFields = ["pincode", "coach_pincode"];
      pincodeFields.forEach(field => {
        const value = formData[field];
        if (value && !pincodeRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be a valid 6-digit pincode`;
        }
      });

      // Bank account: must be 9 to 18-digit number
      let bankAccountRegex=/^(?!0+$)\d{9,18}$/;
      const bankAccountFields = ["player_bank_account_number", "coach_bank_account_number"];
      bankAccountFields.forEach(field => {
        const value = formData[field];
        if (value && !bankAccountRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be valid`;
        }
      });

      // IFSE Code: must not be all zeroes
      let IFSECodeRegex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;
      const IFSECodeFields = ["player_ifsc_code", "coach_ifsc_code"];
      IFSECodeFields.forEach(field => {
        const value = formData[field];
        if (value && !IFSECodeRegex.test(String(value))) {
          newErrors[field] = `${fieldName(field)} must be valid`;
        }
      });

      // Email: must match email regex
      if (formData["email"] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData["email"])) {
        newErrors["email"] = "Invalid email format";
      }

      console.log(!formData["applicant_aadhaar"]);
      console.log(!readOnlyFields.includes('aadhar'));
      console.log("adhaar error", !formData["applicant_aadhaar"] && !readOnlyFields.includes('aadhar'));
      if (!formData["applicant_aadhaar"] && !readOnlyFields.includes('aadhar')) {
        console.log("Aadhar Card is required");
        newErrors["applicant_aadhaar"] = "Aadhar Card is required";
      }

    setErrors(newErrors);

    

    if (Object.keys(newErrors).length === 0) {
      // console.log("Submitting form:", formData);
      if (!isDeclared) {
        alert("Please accept the declaration before submitting the form.");
        return;
      }
      submitForm();
    }

  };

  // const handleProfilePhotoChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     setProfilePhoto(imageUrl);
  //     setFormData(prev => ({ ...prev, profilePhoto: file }));
  //   }
  // };

  const numberOnlyFields = [
    "contact",
    "aadhar",
    "pincode",
    "player_bank_account_number",
    "coach_pincode",
    "coach_contact",
    "coach_bank_account_number",
    "rec_dep_mobile",
    "number_of_players",
  ];

  const handleChange = (e, name) => {
    let value = e.target.value;
  
    // If field should accept only numbers
    if (numberOnlyFields.includes(name)) {
      value = value.replace(/\D/g, ""); // Remove non-digit characters
    }
  
    setFormData({ ...formData, [name]: value });
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  return (
    <div className="relative scheme-form-container user-schemes-container">
      <div className="form-container">

        <div className="form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        
        <div>
          <h1 className="form-title">Application for Cash Award Scheme</h1>
          {/* <Badge bg="" className='badge-primary light badge-lg rounded-pill'>Sports Department</Badge> */}
          <span className="badge mb-2 text-white"
              style={{
                  background: "linear-gradient(90deg, #7942D1 0%, #2A1647 100%)",
                  fontSize: "0.80rem",
                  padding: "0.5em 1.5em",
                  borderRadius: "16056.36px"
              }}>Sports Department</span>

        </div>
        <section className="profile-preview-section">
              {/* <div className="profile-photo-container">
                <img src={alreadyUploadedDocUrl+fetchedProfile} alt="Profile Preview" className="profile-photo" />
              </div> */}
            {/* {profilePhoto ? (
              <div className="profile-photo-container">
                <img src={alreadyUploadedDocUrl+fetchedProfile} alt="Profile Preview" className="profile-photo" />
              </div>
            )
            :(
              <input
              type="file"
              accept="image/*"
              onChange={handleProfilePhotoChange}
              style={{ marginBottom: "1rem" }}
            />
            )
            } */}
        </section>

        </div>

        <form onSubmit={handleSubmit} className="form">

          <section className="">
            <h4 className="application-section-heading">1. General Information</h4>
            <div className="form-inline-group">
              <Input label="Player's Name*" placeholder="Enter Player's Name" name="name" value={formData.name} onChange={(e) => handleChange(e, "name")} error={errors.name} isReadOnly={true} />
              <Input label="Father's Name*" placeholder="Enter Father's Name" name="father_name" value={formData.father_name} onChange={(e) => handleChange(e, "father_name")} error={errors.father_name} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField id="dob" label="Date of Birth (D.O.B)*" placeholder="Enter Date of Birth" value={formData.dob} name="dob" type="date" onChange={(e) => handleChange(e, "dob")}  error={errors.dob} isReadOnly={true}/>
              <Select label="Gender*" placeholder="Select Gender" options={genderList} value={formData.gender}  onChange={(e) => handleSelectChange(e, "gender")} error={errors.gender} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Email ID*" placeholder="Enter Email ID" name="email" value={formData.email} onChange={(e) => handleChange(e, "email")} error={errors.email} isReadOnly={true}/>
              <Input label="Contact Number*" placeholder="Enter Contact Number" name="contact"  value={formData.contact} maxLength={10} inputMode="numeric" onChange={(e) => handleChange(e, "contact")} error={errors.contact} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Aadhar Number*" placeholder="Enter Aadhar Number" name="aadhar" maxLength={12} inputMode="numeric" value={formData.aadhar} onChange={(e) => handleChange(e, "aadhar")} error={errors.aadhar} isReadOnly={readOnlyFields.includes('aadhar')} />
              <Input label="Full Address*" placeholder="Enter Full Address" name="address" value={formData.address} onChange={(e) => handleChange(e, "address")} error={errors.address} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Select label="District*" placeholder="Select District" options={districtList} value={formData.district}  onChange={(e) => handleSelectChange(e, "district")} error={errors.district} isReadOnly={readOnlyFields.includes('district')} />
              <Input label="Pincode*" placeholder="Enter Pincode" name="pincode" inputMode="numeric" value={formData.pincode} maxLength={6} onChange={(e) => handleChange(e, "pincode")} error={errors.pincode} isReadOnly={true}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">2. Sport and Competition Details</h4>
            <div className="form-inline-group">
              <Select label="Name of the Sport*" placeholder="Select Name of the Sport" options={sportList} value={formData.sport}  onChange={(e) => handleSelectChange(e, "sport")} error={errors.sport}/>
              <Select label="Name of the Competition*" placeholder="Select Name of the Competition" options={competetionTypes} value={formData.competition} onChange={(e) => handleSelectChange(e, "competition")} error={errors.competition}/>
            </div>
            <div className="form-inline-group">
              <Input label="Name of the Event*" placeholder="Enter Event Name" name="event" onChange={(e) => handleChange(e, "event")} error={errors.event}/>
              <Select label="Medal(s) Received*" placeholder="Select Medal" options={medalList} value={formData.medal}  onChange={(e) => handleSelectChange(e, "medal")} error={errors.medal}/>
            </div>
            <div className="form-inline-group">
              <Select label="Category*" placeholder="Select Sport Category" options={sportCategoryList} value={formData.sport_category_senior_junior}  onChange={(e) => handleSelectChange(e, "sport_category_senior_junior")} error={errors.sport_category_senior_junior}/>
              <Input label="Association through which participated in the competition*" placeholder="Enter Name of the Association" name="association_name" onChange={(e) => handleChange(e, "association_name")} error={errors.association_name}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField id="competition_start_date" label="Competition Start Date*" placeholder="Select Competition Start Date" value={formData.competition_start_date} onChange={(e) => handleChange(e, "competition_start_date")}  error={errors.competition_start_date} />
              {/* <Input label="Competition Start Date*" placeholder="Select Competition Start Date" name="competition_start_date" type="date" onChange={(e) => handleChange(e, "competition_start_date")}  error={errors.competition_start_date}/> */}
              <DatePickerField id="competition_end_date" label="Competition End Date*" placeholder="Select Competition End Date" name="competition_end_date" type="date" value={formData.competition_end_date} onChange={(e) => handleChange(e, "competition_end_date")}  error={errors.competition_end_date}/>
            </div>
            <div className="form-inline-group">
              <Select label="Team/Individual*" placeholder="Select Sport Category" options={sportCategoryTeamIndList} value={formData.sport_category_team_ind}  onChange={(e) => handleSelectChange(e, "sport_category_team_ind")} error={errors.sport_category_team_ind}/>
              {formData.sport_category_team_ind=="2" ? (
              <Input label="Total Number of Player in Team*" placeholder="Enter Number of player" name="number_of_players" value={formData.number_of_players} inputMode="numeric" maxLength={2} onChange={(e) => handleChange(e, "number_of_players")} error={errors.number_of_players}/>
              ):(
                <div className="mb-3"></div>
              )}
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">3. Applicant’s Bank Details</h4>
            <div className="form-inline-group">
              <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" inputMode="numeric" value={formData.player_bank_account_number} maxLength={18} name="player_bank_account_number" onChange={(e) => handleChange(e, "player_bank_account_number")} error={errors.player_bank_account_number} isReadOnly={readOnlyFields.includes('player_bank_account_number')}/>
              <Input label="IFSC Code*" placeholder="Enter IFSC Code" name="player_ifsc_code" maxLength={11} value={formData.player_ifsc_code} onChange={(e) => handleChange(e, "player_ifsc_code")} error={errors.player_ifsc_code} isReadOnly={readOnlyFields.includes('player_ifsc_code')}/>
            </div>
            <div className="form-inline-group">
              <Input label="Bank Name*" placeholder="Enter Bank Name" name="player_bank_name" value={formData.player_bank_name} onChange={(e) => handleChange(e, "player_bank_name")} error={errors.player_bank_name} isReadOnly={readOnlyFields.includes('player_bank_name')}/>
              <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="player_bank_branch" value={formData.player_bank_branch} onChange={(e) => handleChange(e, "player_bank_branch")} error={errors.player_bank_branch} isReadOnly={readOnlyFields.includes('player_bank_branch')}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">4. Coach Details</h4>
            <div className="form-inline-group">
              <Input label="Name of Coach*" placeholder="Enter Name of Coach" name="coach_name" onChange={(e) => handleChange(e, "coach_name")} error={errors.coach_name}/>
              <Input label="Full Address*" placeholder="Enter Full Address" name="coach_address" onChange={(e) => handleChange(e, "coach_address")} error={errors.coach_address}/>
            </div>
            <div className="form-inline-group">
              <Input label="Pincode*" placeholder="Enter Pincode" name="coach_pincode" maxLength={6} inputMode="numeric" value={formData.coach_pincode} onChange={(e) => handleChange(e, "coach_pincode")} error={errors.coach_pincode}/>
              <Input label="Contact Number*" placeholder="Enter Contact Number" inputMode="numeric" value={formData.coach_contact} maxLength={10} name="coach_contact" onChange={(e) => handleChange(e, "coach_contact")} error={errors.coach_contact}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">5. Coach’s Bank Details</h4>
            <div className="form-inline-group">
              <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.coach_bank_account_number} name="coach_bank_account_number" onChange={(e) => handleChange(e, "coach_bank_account_number")} error={errors.coach_bank_account_number}/>
              <Input label="IFSC Code*" placeholder="Enter IFSC Code" maxLength={11} name="coach_ifsc_code" onChange={(e) => handleChange(e, "coach_ifsc_code")} error={errors.coach_ifsc_code}/>
            </div>
            <div className="form-inline-group">
              <Input label="Bank Name*" placeholder="Enter Bank Name" name="coach_bank_name" onChange={(e) => handleChange(e, "coach_bank_name")} error={errors.coach_bank_name}/>
              <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="coach_bank_branch" onChange={(e) => handleChange(e, "coach_bank_branch")} error={errors.coach_bank_branch}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">6. Details of Recommendation of Department/ Institution or Recognized State Sports Association</h4>
            <div className="form-inline-group">
              <Input label="Name of Department / Institution / State Sports Association*" placeholder="Enter Department / Institution / State Sports Association" name="rec_dep_name" onChange={(e) => handleChange(e, "rec_dep_name")} error={errors.rec_dep_name}/>
              <Input label="Name of Officer*" placeholder="Enter Name of Officer" name="rec_dep_officer_name" onChange={(e) => handleChange(e, "rec_dep_officer_name")} error={errors.rec_dep_officer_name}/>
            </div>
            <div className="form-inline-group">
              <Input label="Full Address*" placeholder="Enter Full Address" name="rec_dep_address" onChange={(e) => handleChange(e, "rec_dep_address")} error={errors.rec_dep_address}/>
              <Input label="Mobile Number*" placeholder="Enter Mobile Number" inputMode="numeric" value={formData.rec_dep_mobile} maxLength={10} name="rec_dep_mobile" onChange={(e) => handleChange(e, "rec_dep_mobile")} error={errors.rec_dep_mobile}/>
            </div>

          </section>

          <div className="card">
              <div className="card-header">
                <h4 className="card-title">Upload Documents</h4>
                <small className="card-subtitle">*Documents  should have size less than 2MB</small>
              </div>
              <div className="card-body">

                  <div className="">
                      <div className="form-inline-group">
                        <Input label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach) *" type="file" onChange={(e) => handleFileChange(e, "training_certificate", "pdf")} accept="application/pdf" error={errors.training_certificate} />
                        {fetchedProfile?<ViewDocument label="Upload Applicant's Photo *" filepath={alreadyUploadedDocUrl+fetchedProfile} placeholder="View Photo"/>
                        :<Input label="Upload Applicant's Photo *" type="file" id="formFile" onChange={(e) => handleFileChange(e, "applicant_photo", "photo")}
                            accept=".jpg, .jpeg, .png" error={errors.applicant_photo}/>}
                      </div>
                      <div className="form-inline-group">
                        <Input label="Details related to the training of the instructor on a stamp paper of Rs.10(by player) *" type="file" onChange={(e) => handleFileChange(e, "stamp_paper_training", "pdf")} accept="application/pdf" error={errors.stamp_paper_training} />
                        <Input label="Related Tournament Certificate *" type="file" onChange={(e) => handleFileChange(e, "tournament_certificate", "pdf")} accept="application/pdf" error={errors.tournament_certificate} />
                      </div>
                      <div className="form-inline-group">
                        <Input label="Sports Proof/evidence of participation from Uttrakhand *" type="file" onChange={(e) => handleFileChange(e, "sports_proof", "pdf")} accept="application/pdf" error={errors.sports_proof} />
                        <Input label="Association Verification Form *" type="file" onChange={(e) => handleFileChange(e, "association_verification_form", "pdf")} accept="application/pdf" error={errors.association_verification_form} />
                      </div>
                      <div className="form-inline-group">
                        {readOnlyFields.includes('aadhar')?<ViewDocument label="Aadhaar Card *" filepath={alreadyUploadedDocUrl+fetchedAadhaar} placeholder="View Aadhaar"/>
                        :<Input label="Aadhaar Card *" type="file" onChange={(e) => handleFileChange(e, "applicant_aadhaar", "pdf")} accept="application/pdf" error={errors.applicant_aadhaar} />}
                        <Input label="Any Other Documents (Optional)" type="file" onChange={(e) => handleFileChange(e, "other_doc", "pdf")} accept="application/pdf" />
                      </div>
                  </div>
              </div>
          </div>

          <div className="declaration-section" style={{ margin: "0rem 0", display: "flex", alignItems: "flex-start" }}>
            <input
              type="checkbox"
              id="declaration"
              name="declaration"
              checked={isDeclared}
              onChange={(e) => setIsDeclared(e.target.checked)}
              style={{ marginTop: "4px", marginRight: "8px" }}
            />
            <label htmlFor="declaration" style={{ fontSize: "0.9rem", color: "#555" }}>
              I hereby declare that all the information provided in the application is true and correct in every respect
              and if any information is found to be incorrect the application shall be liable to be rejected. <span style={{ color: "red" }}>*</span>
            </label>
          </div>

          <div className="form-submit">
            <button type="submit" disabled={submitLoading}>
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              Submit Form
              {submitLoading && <span className="spinner"></span>}
            </span>
            </button>
          </div>
        </form>

      </div>
      
      {modalOpen && (
        <Modal icon={green_check} message="Your grant schemes and scholarship form has been successfully submitted." onSubmit={() => {setModalOpen(false); navigate(`/grant-scheme`);}} buttonText="Continue to Dashboard" appId={applicationId}/>
      )}

    </div>
  );
};

export default SchemeForm;
